import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../../components/legal/LegalPageLayout';
import { SELLER } from './sellerInfo';

export const PreInformationPage = () => (
  <LegalPageLayout title="Ön Bilgilendirme Formu" enTitle="Pre-Information Form" updatedAt="16 Ekim 2026">
    <p className="legal-intro">
      Bu form, Mesafeli Sözleşmeler Yönetmeliği uyarınca, abonelik satın alınmadan önce Alıcı'yı bilgilendirmek
      amacıyla hazırlanmıştır.
    </p>

    <h2>1. Satıcı Bilgileri</h2>
    <ul>
      <li>Ad soyad / ticari ad: {SELLER.name} — {SELLER.tradeName}</li>
      <li>Vergi kimlik no: {SELLER.taxNumber} ({SELLER.taxOffice})</li>
      <li>Adres: {SELLER.address}</li>
      <li>Telefon: {SELLER.phone}</li>
      <li>E-posta: <a href={`mailto:${SELLER.email}`}>{SELLER.email}</a></li>
      <li>KEP: {SELLER.kep}</li>
    </ul>

    <h2>2. Hizmetin Temel Nitelikleri</h2>
    <p>
      Microsoft 365 kullanan kurumlar için bulut tabanlı e-posta imza yönetimi: imza şablonlarının merkezi tasarımı,
      gruplara atanması, kampanya ve anket içerikleri ve Outlook eklentisi aracılığıyla imzaların iletilere
      otomatik eklenmesi. Ayrıntılar <Link to="/kullanim-sartlari">Kullanım Şartları</Link>'ndadır.
    </p>

    <h2>3. Fiyat</h2>
    <ul>
      <li>Kullanıcı başına aylık 2 ABD doları; yıllık ödemede %20 indirimli olarak kullanıcı başına yıllık 19,20 ABD doları.</li>
      <li>Fiyatlara %20 KDV dahil değildir.</li>
      <li>Tahsilat Türk lirası olarak, ödeme anındaki T.C. Merkez Bankası döviz satış kuruyla yapılır; ödenecek tutar sipariş özetinde gösterilir.</li>
      <li>Otomatik yenilemelerde tutar, yenileme günündeki kurla yeniden hesaplanır.</li>
    </ul>

    <h2>4. Ödeme ve İfa</h2>
    <p>
      Ödeme PAYTR altyapısıyla kredi/banka kartıyla yapılır. Hizmet, ödeme onayıyla birlikte elektronik ortamda derhal
      kullanıma açılır. Abonelik süresi seçilen döneme göre 30 veya 365 gündür; deneme sürecindeyken yapılan ödemede
      yeni dönem deneme süresinin bitiminden başlar.
    </p>

    <h2>5. Cayma Hakkı</h2>
    <p>
      Elektronik ortamda anında ifa edilen hizmet niteliğinde olduğundan, Mesafeli Sözleşmeler Yönetmeliği md. 15/1-ğ
      uyarınca cayma hakkı bulunmamaktadır. Otomatik yenilemeyi istediğiniz zaman kapatarak aboneliği dönem sonunda
      sonlandırabilirsiniz.
    </p>

    <h2>6. Şikâyet ve Başvuru</h2>
    <p>
      Talep ve şikâyetleriniz için <a href={`mailto:${SELLER.email}`}>{SELLER.email}</a> adresine yazabilirsiniz.
      Tüketiciler, parasal sınırlar dahilinde Tüketici Hakem Heyeti'ne veya Tüketici Mahkemesi'ne başvurabilir.
      Sözleşmenin tamamı için <Link to="/mesafeli-satis-sozlesmesi">Mesafeli Satış Sözleşmesi</Link>'ne bakınız.
    </p>
  </LegalPageLayout>
);

export default PreInformationPage;
